// src/components/Header.js
import React, { useState, useEffect, useRef } from 'react';
import './Header.css';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { FaVolumeUp, FaVolumeMute, FaVolumeDown } from 'react-icons/fa';
import { useBackgroundAudio } from './BackgroundAudio';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const audioControlRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const {
    isMuted,
    volume,
    showVolumeSlider,
    setShowVolumeSlider,
    toggleMute,
    handleVolumeChange,
    isMobileAudioDisabled,
  } = useBackgroundAudio();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (audioControlRef.current && !audioControlRef.current.contains(event.target)) {
        setShowVolumeSlider(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [setShowVolumeSlider]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen); // Toggle the menu state
  };

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleNavigation = (sectionId) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        scrollToSection(sectionId);
      }, 100);
    } else {
      scrollToSection(sectionId);
    }
    toggleMenu(); // Close the menu after clicking
  };

  const handleBrandClick = (e) => {
    if (location.pathname === '/') {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <nav className={`navbar navbar-expand-lg navbar-dark ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <Link className="navbar-brand" to="/" onClick={handleBrandClick}>
          <span className="logo-text">Junaid <span className="highlighted-name">Nasir</span></span>
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          aria-controls="navbarNav"
          aria-expanded={isMenuOpen}
          aria-label="Toggle navigation"
          onClick={toggleMenu}
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`} id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link className="nav-link" to="/" onClick={() => handleNavigation('home')}>Home</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/" onClick={() => handleNavigation('about')}>About</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/" onClick={() => handleNavigation('skills')}>Skills</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/" onClick={() => handleNavigation('services')}>Services</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/" onClick={() => handleNavigation('experience')}>Experience</Link>
            </li>
            {/* <li className="nav-item">
              <Link className="nav-link" to="/" onClick={() => handleNavigation('projects')}>Projects</Link>
            </li> */}
            <li className="nav-item">
              <Link className="nav-link" to="/" onClick={() => handleNavigation('testimonials')}>Testimonials</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/contact" onClick={toggleMenu}>Contact</Link>
            </li>
            <li className="nav-item portfolio-nav-item">
              <Link className="nav-link highlight-portfolio" to="/projects" onClick={toggleMenu}>Portfolio</Link>
            </li>
            {!isMobileAudioDisabled && (
            <li className="nav-item audio-nav-item" ref={audioControlRef}>
              <div className="audio-control">
                <button
                  type="button"
                  className="audio-toggle-btn"
                  onClick={toggleMute}
                  onMouseEnter={() => setShowVolumeSlider(true)}
                  aria-label={isMuted ? 'Unmute background music' : 'Mute background music'}
                  title={isMuted ? 'Unmute' : 'Mute'}
                >
                  {isMuted || volume === 0 ? (
                    <FaVolumeMute />
                  ) : volume < 0.5 ? (
                    <FaVolumeDown />
                  ) : (
                    <FaVolumeUp />
                  )}
                </button>
                {showVolumeSlider && (
                  <div
                    className="audio-volume-popup"
                    onMouseLeave={() => setShowVolumeSlider(false)}
                  >
                    <input
                      type="range"
                      min="0"
                      max="1"
                      step="0.05"
                      value={isMuted ? 0 : volume}
                      onChange={(e) => handleVolumeChange(parseFloat(e.target.value))}
                      className="audio-volume-slider"
                      aria-label="Background music volume"
                    />
                  </div>
                )}
              </div>
            </li>
            )}
          </ul>
          {/* <button className="btn btn-primary ms-3">Get in Touch</button> */}
        </div>
      </div>
    </nav>
  );
};

export default Header;
